import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ColorsControlSection from '../ColorsControlSection/ColorsControlSection';
import CardLayoutSettings from '../../../CardLayoutSettings';
var CardsAndTrainerSection = function () {
    return (_jsxs("div", { children: [_jsx(ColorsControlSection, { isDrawer: true, title: 'suits', type: '' }), _jsx(CardLayoutSettings, {}), _jsx(ColorsControlSection, { isDrawer: true, title: 'trainer', type: '' })] }));
};
export default CardsAndTrainerSection;
